import {
  getProductVariantDetails,
  fetchProductDetails,
  addProductReview,
  listProductFeedback,
  fetchRelatedIems,
  fetchNewStores,
  fetchAllItems,
} from './services';
import { structureItemData } from '/src/helpers/items';

export default {
  namespaced: true,
  state: {
    categoryList: {},
    productDetailsList: {},
    productVariantData: {},
    relatedItemList: {},
    productFeedbackList: [],
    newStores: [],
    defaultLocation: {
      City: '',
      Country: '',
      State: '',
      zip: '',
    },
    itemSuggestions: [],
    trendingItems: [],
    isLoading: false,
  },
  getters: {
    getProductData(state) {
      return id => state.productDetailsList[id];
    },
    getRelatedItemsData(state) {
      return id => state.relatedItemList[id];
    },
    getProductFeedbackData(state) {
      return id => state.productFeedbackList[id];
    },
  },
  actions: {
    fetchNewStores: async ({ commit, state }, payload) => {
      try {
        if (
          !state.newStores ||
          Object.keys(state.newStores).length === 0 ||
          payload.refresh
        ) {
          delete payload.refresh;
          commit('setNewStores', []);
          const data = await fetchNewStores(payload);
          commit('setNewStores', data.response);
        }
      } catch (e) {
        //
      }
    },

    fetchProductDetails: async ({ commit, state }, item, refresh = false) => {
      try {
        if (!state.productDetailsList[item] || refresh) {
          const data = await fetchProductDetails(item);
          commit('setProductDataList', {
            key: item,
            value: structureItemData([data])[0],
          });
        }
      } catch (error) {
        throw Error(
          error?.response?.data?.message ||
            `Api failed with error: ${error.message}`
        );
      }
    },

    fetchProductVariantDetails: async ({ commit, state }, payload) => {
      try {
        let res = await getProductVariantDetails(payload.variantId);
        commit('setProductVariantData', {
          value: res.data.response[0],
          key: payload.variantId,
        });

        const variantInfo = res.data.response[0].variations.find(
          el => el._id == res.data.response[0].variationId
        );

        commit('setProductDataList', {
          key: payload.itemId,
          value: {
            ...state.productDetailsList[payload.itemId],
            ...res.data.response[0],
            variations: state.productDetailsList[payload.itemId].variations,
            ['Deal Price']: variantInfo.DealPrice,
          },
        });
        return res;
      } catch (error) {
        throw Error(
          error?.response?.data?.message ||
            `Api failed with error: ${error.message}`
        );
      }
    },

    updateProductReview: async (_, payload) => {
      let res = await addProductReview(payload);
      return res;
    },

    fetchProductFeedback: async ({ commit, state }, id, refresh = false) => {
      try {
        if (!state.productFeedbackList[id] || refresh) {
          let result = await listProductFeedback(id);
          commit('setProductFeedback', {
            key: id,
            value: result[0],
          });
        }
      } catch (e) {
        console.log(e);
      }
    },

    fetchRelatedItemData: async (
      { commit, state },
      payload,
      refresh = false
    ) => {
      try {
        if (!state.relatedItemList[payload?.catalogs[0]] || refresh) {
          const result = await fetchRelatedIems(payload);
          commit('setRelatedItemData', {
            key: payload?.catalogs[0],
            value: structureItemData(result[payload?.catalogs[0]]),
          });
        }
      } catch (e) {
        console.log(e);
      }
    },

    fetchAllItems: async ({ commit, state }, refresh = false) => {
      try {
        if (
          (!state.itemSuggestions.length && !state.trendingItems.length) ||
          refresh
        ) {
          commit('setState', {
            itemSuggestions: [],
            trendingItems: [],
            //isLoading : true
          });
          const result = await fetchAllItems({
            //city: [state.defaultLocation.City],
            page: { page: 1, itemsPerPage: 20 },
          });

          commit('setState', {
            itemSuggestions: structureItemData(result.data.itemSuggestions),
            trendingItems: structureItemData(result.data.trendingItems),
            //isLoading : false
          });
        }
      } catch (e) {
        //
      }
    },

    setLocation: ({ commit, dispatch }, data) => {
      commit('setLocationData', data);
      dispatch('fetchAllItems', true);
      dispatch('fetchNewStores', true);
    },
  },

  mutations: {
    setProductDataList: (state, data) => {
      state.productDetailsList = {
        ...state.productDetailsList,
        [data.key]: data.value,
      };
    },

    setProductVariantData: (state, payload) => {
      state.productVariantData = {
        ...state.productVariantData.City,
        [payload.key]: payload.value,
      };
    },

    setRelatedItemData: (state, data) => {
      state.relatedItemList = {
        ...state.relatedItemList,
        [data.key]: data.value,
      };
    },

    setProductFeedback: (state, data) => {
      state.productFeedbackList = {
        ...state.productFeedbackList,
        [data.key]: data.value,
      };
    },

    setNewStores(state, data) {
      state.newStores = data;
    },

    setState: (state, data) => {
      Object.keys(data).map(field => {
        state[field] = data[field];
      });
    },

    setLocationData: (state, data) => {
      state.defaultLocation = data;
    },
  },
};
